import { render, staticRenderFns } from "./SummaryOfWinnings.vue?vue&type=template&id=1cd8dcbe&scoped=true"
import script from "./SummaryOfWinnings.vue?vue&type=script&lang=js"
export * from "./SummaryOfWinnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd8dcbe",
  null
  
)

export default component.exports